import { render } from "./MobileAd.vue?vue&type=template&id=34aff940&scoped=true"
import script from "./MobileAd.vue?vue&type=script&lang=js"
export * from "./MobileAd.vue?vue&type=script&lang=js"

import "./MobileAd.vue?vue&type=style&index=0&id=34aff940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aff940"]])

export default __exports__